import React, { useState } from "react";

import StudentPracticalExamsTab from "./StudentPracticalExamsTab";
import StudentTheoryExamsTab from "./StudentTheoryExamsTab";

const EXAM_TABS = [
   { key: "theory", label: "Teoretic" },
   { key: "practical", label: "Practic" },
];

export default function StudentExamsTab() {
   const [examTab, setExamTab] = useState("theory");

   return (
      <div className="studentsProfileUI__exams">
         <div className="studentsProfileUI__tabs studentsProfileUI__tabs--sub">
            {EXAM_TABS.map((item) => (
               <button
                  key={item.key}
                  type="button"
                  className={
                     "studentsProfileUI__tab" +
                     (examTab === item.key ? " is-active" : "")
                  }
                  onClick={() => setExamTab(item.key)}
               >
                  {item.label}
               </button>
            ))}
         </div>

         {examTab === "theory" ? (
            <StudentTheoryExamsTab />
         ) : (
            <StudentPracticalExamsTab />
         )}
      </div>
   );
}
